import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { AsyncSelector } from '../../../components/selector/AsyncSelector';
import DownloadReportButton from '../../../components/button/DownloadReportButton';
import { useSelector } from 'react-redux';

const messages = defineMessages({
  tooltipMsg: {
    id: 'tooltip.download_open_window_hint',
    // eslint-disable-next-line max-len
    defaultMessage:
      'Reports are opened in a <strong>new window</strong>. Please <strong>enable pop-up</strong> windows for this website.',
  },
  jobCompatibility: { id: 'superlink.jobReport', defaultMessage: 'Ranking Report (job compatibility)' },
});

const SuperLinkJobReportPanel = ({
  listJobProfiles,
  searchJob,
  isJpLoading,
  targetJobProfile,
  setLocale,
  setJobProfile,
  locale,
  changeSurveyPrinterFiendly,
  reportParams,
}) => {
  const { formatMessage, formatHTMLMessage } = useIntl();
  const { translatedTags } = useSelector((state) => state.i18n);


  const tooltip = formatHTMLMessage(messages.tooltipMsg);

  return (
    <Panel header={formatMessage(messages.jobCompatibility)}>
      <div className="form-group">
        <p
          className="sentence-capitalized"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: tooltip }}
        />
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <div className="form-group">
            <label className="field-label" htmlFor="superlink-jobProfileId">
              <FormattedMessage id="attrs.targetJob" defaultMessage="Target Job Profile" />
            </label>
            <AsyncSelector
              filter="contains"
              data={listJobProfiles}
              onChange={(value) => setJobProfile(value.id)}
              dataSearch={searchJob}
              processing={isJpLoading}
              value={targetJobProfile}
              valueField="id"
              textField="name"
            />
          </div>
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <div className="form-group">
            <label htmlFor="locale" className="field-label">
              <FormattedMessage id="attrs.locale" defaultMessage="Preferred Language" />
            </label>
            <Dropdown
              options={translatedTags}
              filter
              onChange={(loc) => {
                setLocale(loc.value);
              }}
              value={locale}
            />
          </div>
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <Checkbox
            name="printerFriendlyReport"
            inputId="printerFriendlyReport"
            onChange={changeSurveyPrinterFiendly}
            checked={reportParams.printerFriendly}
          />
          <FormattedMessage
            id="preferences.prefer-printer-friendly-reports"
            defaultMessage="I prefer printer friendly reports"
          >
            {(text) => <label htmlFor="printerFriendlyReport"> {text}</label>}
          </FormattedMessage>
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-12">
          <DownloadReportButton
            buttonClass="btn-sm"
            reportParams={reportParams}
            typeButton="generateReport"
            additionalClass="clearfix text-center"
            type="SUPERLINK_REPORT"
            isDisabled={!targetJobProfile}
          />
        </div>
      </div>
    </Panel>
  );
};

SuperLinkJobReportPanel.propTypes = {
  searchJob: PropTypes.func.isRequired,
  changeSurveyPrinterFiendly: PropTypes.func.isRequired,
  handleChangeState: PropTypes.func.isRequired,
  isJpLoading: PropTypes.bool.isRequired,
  targetJobProfile: PropTypes.string,
  locale: PropTypes.string.isRequired,
  listJobProfiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  reportParams: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SuperLinkJobReportPanel;
